import { render, staticRenderFns } from "./OfferItemCampus.vue?vue&type=template&id=df6699a6"
import script from "./OfferItemCampus.vue?vue&type=script&lang=js"
export * from "./OfferItemCampus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df6699a6')) {
      api.createRecord('df6699a6', component.options)
    } else {
      api.reload('df6699a6', component.options)
    }
    module.hot.accept("./OfferItemCampus.vue?vue&type=template&id=df6699a6", function () {
      api.rerender('df6699a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/OfferItemCampus.vue"
export default component.exports